import React from 'react'

const BgAnimated = ({children}) => {
  return (
    <div className="background">
   <span className="cuadrito" ></span>
   <span className="cuadrito" ></span>
   <span className="cuadrito" ></span>
   <span className="cuadrito" ></span>
   <span className="cuadrito" ></span>
   <span className="cuadrito" ></span>
   <span className="cuadrito" ></span>
   <span className="cuadrito" ></span>
   <span className="cuadrito" ></span>
   <span className="cuadrito" ></span>
   <span className="cuadrito" ></span>
   <span className="cuadrito" ></span>
   <span className="cuadrito" ></span>
   <span className="cuadrito" ></span>
   <span className="cuadrito" ></span>
   <span className="cuadrito" ></span>
   <span className="cuadrito" ></span>
   <span className="cuadrito" ></span>
   <span className="cuadrito" ></span>
   <span className="cuadrito" ></span>
   {children}
</div>
  )
}

export default BgAnimated